import request from '@/utils/request'
// import verificationJson from './mock/identificationVerification.json'

export function commCode(cmmCdGrpId) {
    let params = {
        cmmCdGrpId: cmmCdGrpId
    }
    return request({
        url: `/ococ/datacapture/v1/commonCodes`,
        method: 'get',
        params
    })
}

export function xPayCardAuthcheck(reqData) {
    let cardAuthInfo = {
        lgdPan: window.btoa(reqData.lgdPin + reqData.lgdPan), // 카드 번호
        lgdExpyear: (reqData.lgdExpyear).substr(2,2), // 카드 유효 년도
        lgdExpmon: reqData.lgdExpmon, // 카드유효월
        lgdBuyer: reqData.lgdBuyer, // 신청자
        lgdPin: '', // 비밀번호 앞자리 2자리
        lgdPrivateno: reqData.lgdPrivateno, // 주민번호 앞 6자리
        dealCd: reqData.dealCd,   // 대리점코드
        onetMblAppfNo: reqData.onetMblAppfNo, // 신청서번호
        miltaryAgentYn: reqData.miltaryAgentYn
    }

    return request({
        url: `/ococ/datacapture/auth/xPayCardAuthcheck`,
        method: 'post',
        data: cardAuthInfo
    })
}

// 범용 공인인증
export function publicAuthSend(reqData) {
    return request({
        url: `/ococ/datacapture/auth/publicAuthSend`,
        method: 'get',
        headers: {
            'custPersId': window.btoa(reqData.custPersId),
            'encCustNm': window.btoa(encodeURIComponent(reqData.custNm)),
            'onetMblAppfNo': reqData.onetMblAppfNo,
            'pymnDivsCd': reqData.pymnDivsCd,
        },
    })
}

export function publicAuthResult(reqData) {
    let params = {
        priinfo: reqData
    }
    return request({
        url: `/ococ/datacapture/auth/publicAuthResult`,
        method: 'get',
        params
    })
}

// 모바일 인증
export function smsAuthSend(reqData) {
    let mobileInfo = {
        phoneNo: reqData.phoneNo,
        dealId: reqData.dealCd,
        onetMblAppfNo: reqData.onetMblAppfNo,
        buyer: reqData.lgdBuyer,
        birthDay: reqData.lgdPrivateno
    }
    return request({
        url: `/ococ/datacapture/auth/smsAuthSend`,
        method: 'post',
        data: mobileInfo
    })
}
// 모바일인증 결과체크 페이지
export function smsAuthCheck(reqData) {
    let mobileAuthInfo =  {
        onetMblAppfNo: reqData.onetMblAppfNo,
        smsval: reqData.smsval
    }
    return request({
        url: `/ococ/datacapture/auth/smsAuthCheck`,
        method: 'post',
        data: mobileAuthInfo
    })
}

//KCB 인증 추가  조회
export function getKcbCardAuthInfo(reqData) {
    let kcbInfo = {
        onetMblAppfNo: reqData.onetMblAppfNo, // 신청서번호
        miltaryAgentYn: reqData.miltaryAgentYn,
        cardNo: reqData.cardNo ,// 카드번호 앞 6자리
        rsltBirthday :reqData.rsltBirthday,
        rsltName:reqData.rsltName,
    }

    return request({
        url: `/ococ/datacapture/auth/getKcbCardAuthInfo`,
        method: 'post',
        data: kcbInfo
    })
}

//KCB 인증 추가  오픈마켓 사용
export function callKcbPopup(reqData) {


    return new Promise((resolve,reject)=>{
        window.cbAuthPop = (res) =>{
            resolve(res)
        }
        let url = '/auth-popup/kcb-auth-popup?mdlTkn='+reqData

         window.open(url,"popKcb","width=450,height=550,top=100,left=100,fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no")
       
        
    })
}

//kcb 결과 리턴
export function resultKcb(reqData) {
    
    let params = {
        mdlTkn: reqData
    }
     return request({
         url: `/ococ/datacapture/auth/resultKcb`,
         method: 'get',
         params
     })
 }

export function saveKcbCardAuthInfo(reqData) {
   // console.log(reqData.cardNo)
    let kcbInfo = {
        onetMblAppfNo: reqData.onetMblAppfNo, // 신청서번호
        cardKndCd: reqData.cardKndCd,
        dealCd:reqData.dealCd,
        rsltName: reqData.rsltName,
        rsltBirthday: reqData.rsltBirthday,
        cardNo: reqData.cardNo, // 카드번호 앞 6자리
        mdlTkn:reqData.mdlTkn,
    }
    return request({
        url: `/ococ/datacapture/auth/saveKcbCardAuthInfo`,
        method: 'post',
        data: kcbInfo
    })
}


// [C20230630_99755_4599755]공인인증 오픈마켓사용 2023.07.11 장희정 추가
export function callKmcPublAuthPopup(params) {
    let PUB_window;
    let PUB_window_move;
    

   // var UserAgent = navigator.userAgent;

    // 기본 팝업 size
    var jwidth	= "450";
    var jHeight	= "630";

    var UserAgent = navigator.userAgent.toLowerCase();
    
    if(UserAgent.indexOf("chrome") != -1){
        jwidth	= "400";
        jHeight	= "645";
    }else if(UserAgent.indexOf("safari") != -1){
        jwidth	= "441";
        jHeight	= "588";
    }
    

    return new Promise((resolve, reject) => {
        window.cbAuthPop = (res) => {
            resolve(res)
        }
        window.normalauthdata = {
            custNm: params.custNm,
            custPersId: params.custPersId,
            onetMblAppfNo: params.onetMblAppfNo
        }

        let url = '/auth-popup/kmc-publ-auth-popup'
        PUB_window= window.open(url, 'PUBWindow',  'width='+jwidth+', height='+jHeight+', resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' )
    })
}


 // [C20230630_99755_4599755]공인인증 오픈마켓사용 2023.07.11 장희정 추가
    export function getKmcPublEncrypt(reqData) {
        return request({
            url: `/ococ/datacapture/v1/openmarket/v1/kmc/publ/getKmcPublEncrypt`,
            method: 'get',
            headers: {
                'custPersId': window.btoa(reqData.custPersId),
                'encCustNm': window.btoa(encodeURIComponent(reqData.custNm)),
                'onetMblAppfNo': reqData.onetMblAppfNo
            }
        })
    }

    
    /* // [C20230630_99755_4599755]공인인증 오픈마켓사용 2023.07.11 장희정 추가*/
    export function kmcPublAuthResult(reqData) {
        return request({
            url: `/ococ/datacapture/v1/openmarket/v1/kmc/publResult`,
            method: 'post',
            data: reqData
        })
    }

    export function callInicisPopup(params) {
    
        let sa_popup;
        let _width = 400;
		let _height = 620;
		var xPos = (document.body.offsetWidth/2) - (_width/2); // 가운데 정렬
		xPos += window.screenLeft; // 듀얼 모니터일 때
    

    
        return new Promise((resolve, reject) => {
            window.cbAuthPop = (res) => {
                resolve(res)
            }
            window.authdata = {
                userName:params.userName,
                userBirth: params.userBirth,
                userPhone: params.userPhone,
                onetMblAppfNo: params.onetMblAppfNo,
                dealCd:params.dealCd,
                directAgency : params.directAgency
            }
    
            let url = '/auth-popup/inicis-auth-popup'
            sa_popup= window.open(url,  "sa_popup", "width="+_width+", height="+_height+", left="+xPos+", menubar=yes, status=yes, titlebar=yes, resizable=yes")
        })
    }
    
    export function getInicisEncrypt(reqData) {
   //  alert(reqData.userName)

   let inicisInfo ={
                    onetMblAppfNo: reqData.onetMblAppfNo,
                    directAgency : reqData.directAgency,
                    dealCd:reqData.dealCd
                    }
        return request({
            url: `/ococ/datacapture/auth/getInicisAuthInfo`,
            method: 'post',
            headers: {
                'userBirth':window.btoa(reqData.userBirth),
                'userName': window.btoa(encodeURIComponent(reqData.userName)),
                'userPhone':window.btoa(reqData.userPhone),
            },
            data: inicisInfo
        })
    }
